import type { YakurekiDetail } from '@/shared/types/yakurekiCore'

import { formatMonthDay } from '../../utils/formatPrepDate'
import { PrescriptionWithDiffPanel } from '../PrescriptionWithDiffPanel'
import { PrepSection } from './parts'

const previousAside = (
  previous: YakurekiDetail['previous_prescription_data'],
  isInitial: boolean
) => {
  if (!previous) return isInitial ? '初回' : undefined
  const on = formatMonthDay(previous.prescription_date)
  return ['前回', on, previous.institution_name].filter(Boolean).join(' ')
}

// 「前回との差」. 服薬指導の面と監査の面の両方に置く (yakureki-back log/262 決定 15.
// 決定 1 の「監査の面へ移す」を上書き: 投薬する人も前回からの変化を見て話す).
export const PreviousDiffSection = ({
  event,
  isInitial,
}: {
  event: YakurekiDetail
  isInitial: boolean
}) => (
  <PrepSection
    title="前回との差"
    aside={previousAside(event.previous_prescription_data, isInitial)}
  >
    <PrescriptionWithDiffPanel
      current={event.current_prescription_data ?? null}
      previous={event.previous_prescription_data ?? null}
    />
  </PrepSection>
)
